module.exports = __webpack_public_path__ + "static/media/alertsVault.2fd2c468.svg";